import {useQuery} from 'react-query'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {useEffect, useState} from 'react'
import {Role} from './_model'
import {searchItems} from '../../../utils/helperFunction/_helper'
import TableContent from '../../../utils/components/table-content/TableContent'
import roleListColumn from './roleListColumn'
import TablePagination from '../../../utils/components/table-content/TablePagination'

type Props = {
  handleSelectRole: (type: string, role: Role) => void
  searchTerm: string
}

const GET_ROLE_LIST_URL = `${BASE_URL}/api/protect/getAllRole`

const RoleList = ({handleSelectRole, searchTerm}: Props) => {
  const {
    pagination: {totalElement, page, size},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)

  const [roleList, setRoleList] = useState<Role[]>([])

  const {data, isLoading, error} = useQuery({
    queryKey: ['userRole', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_ROLE_LIST_URL, {
        params: {
          page,
          size,
        },
      })
      const data = await response.data
      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
  })

  const handleSelect = (selectType: string, id: number) => {
    const selected = roleList.find((role) => role.id_level === id)

    if (selected) {
      handleSelectRole(selectType, selected)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof Role)[] = ['level_name']
      const filtered = searchItems(data.list, searchTerm, keys)

      setRoleList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [searchTerm, data])

  return (
    <div>
      <TableContent
        isLoading={isLoading}
        error={error as Error}
        tableData={roleList}
        tableColumn={roleListColumn(handleSelect)}
      >
        {isLoading && !data ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <TablePagination
            totalElement={totalElement}
            isLoading={isLoading}
            itemsPerPage={size}
            currentPage={page}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContent>
    </div>
  )
}

export default RoleList
